export interface ShareLogFormatterProps {
  action: string;
  performedBy: string;
}
export default function ShareLogFormatter({
  action,
  performedBy,
}: ShareLogFormatterProps) {
  let message = action;
  if (action === 'Privacy.ShareOptIn') {
    message = `${performedBy} has opted in to data sharing`;
  }
  if (action === 'Privacy.ShareOptOut') {
    message = `${performedBy} has opted out of data sharing`;
  }
  return <span data-exclude-lg>{message}</span>;
}
